import React from 'react'
import {DateFormatter, DayModifiers, DayPicker} from 'react-day-picker'
import moment from 'moment'
import styled from 'styled-components'
import {format} from 'date-fns'
import {ja} from 'date-fns/locale'

interface Props {
    onDayClick?:(
        day: Date,
        modifiers: DayModifiers,
        e: React.MouseEvent,
    ) => void

    today: Date
    holidays: string[]
    selectedDay?: Date
}

const CalendarForReservation: React.FC<Props> = props => {
    const holidayList = props.holidays.map(holiday => new Date(holiday))
    const modifiers = {
        sun: {dayOfWeek: [0]},
        sat: {dayOfWeek: [6]},
        holidays: holidayList
    }
    const modifiersStyles = {
        sun: {color: '#ff0000'},
        sat: {color: '#0000ff'},
        holidays: {color: '#ff0000'},
        today:{color: '#3f51b5'}
    }

    const todayMoment = moment(props.today)
    const selectableEndMonth: moment.Moment = todayMoment.clone().add(1, 'year').month(11)
    const selectableStartMonth: moment.Moment = moment('2020-01-01 00:00:00')

    return <DayPickerStyleAdmin><DayPicker
        disabled={{before: selectableStartMonth.toDate()}}
        fromMonth={selectableStartMonth.toDate()}
        toMonth={selectableEndMonth.toDate()}
        modifiers={modifiers}
        modifiersStyles={modifiersStyles}
        defaultMonth={props.selectedDay || props.today}
        locale={ja}
        formatters={{ formatCaption }}
        selected={props.selectedDay}
        onDayClick={props.onDayClick}
    /></DayPickerStyleAdmin>
}

const formatCaption: DateFormatter = (date, options) => {
    const y = new Date(date.toLocaleString('ja')).getFullYear();
    const m = format(date, 'MM', { locale: ja });
    return `${y}年 ${Number(m)}月`;
}

CalendarForReservation.displayName = 'CalendarForReservation'
export default CalendarForReservation

const DayPickerStyleAdmin = styled.div`
.rdp {
  font-size: 16px;
  --rdp-cell-size: 35px;
}
.rdp-caption_label {
  font-size: 16px;
}
`
